module.exports = __webpack_public_path__ + "img/no-hero-stake.7d529d30.png";